import React, { useState, Fragment } from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import {
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  IconButton,
  TextField
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { Label, useLabelStyles } from '../../common/Label';
import I18n from '../../../config/locales';
import { getGridProfileToken } from '../../../containers/Dashboard/actions';
import Snackbar from '../../SnakBar';

const useStyles = makeStyles(theme => ({
  dialogHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& h6': {
      color: '#335977',
      fontSize: 28,
      fontWeight: 'bold'
    }
  },
  closeButton: {
    padding: 0
  },
  dialogContent: {
    border: '1px solid #7070704d',
    padding: theme.spacing(2),
    margin: theme.spacing(0, 3.5, 3.5)
  },
  dialogContentText: {
    marginBottom: theme.spacing(3)
  },
  button: {
    fontSize: 14,
    height: theme.spacing(4.5),
    color: theme.palette.primary.white,
    minWidth: theme.spacing(15),
    fontWeight: 'bold',
    marginBottom: theme.spacing(1)
  },
  inputField: {
    maxWidth: theme.spacing(37.5),
    width: '100%'
  },
  dialogContentTokenText: {
    marginBottom: 0,
    color: '#43425D'
  },
  gridProfileToken: {
    border: '1px solid #7070704d',
    width: '50%',
    maxWidth: 300,
    padding: theme.spacing(0.5, 1),
    margin: theme.spacing(1, 0, 2),
    overflow: 'hidden'
  }
}));

const GridProfileToken = props => {
  const { handlePopupClose = () => {}, getGridProfileToken } = props;
  const classes = useStyles();
  const labelClass = useLabelStyles();
  const [ serialNumber, setSerialNumber ] = useState('');
  const [ authNumber, setAuthNumber ] = useState('');
  const [ errorMessage, setErrorMessage ] = useState('');
  const [ gridProfileToken, setGridProfileToken ] = useState('');

  const preventDefault = (event, key) => {
    if (event.which !== 8 && event.which !== 0 && (event.which < 48 || event.which > 57)) {
      event.preventDefault();
    }
  };

  const showErrorMessage = message => {
    setErrorMessage(message);
    setTimeout(() => {
      setErrorMessage('');
    }, 4000);
  };

  const showGridProfileToken = token => {
    setGridProfileToken(token);
  };

  const getToken = () => {
    getGridProfileToken({ serialNumber, authNumber, successCbk: showGridProfileToken, failureCbk: showErrorMessage });
  };

  return (
    <Fragment>
      <Dialog
        open
        onClose={handlePopupClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle className={classes.dialogHeader} disableTypography>
          <Typography variant="h6">{I18n.t('dashboard.gridProfileToken')}</Typography>
          <IconButton aria-label="close" className={classes.closeButton} onClick={handlePopupClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          {gridProfileToken ? (
            <DialogContentText component="div" className={classes.dialogContentTokenText}>
              <Typography component="div">{I18n.t('dashboard.ProfileTokenText')}</Typography>
              <Typography component="div" className={classes.gridProfileToken}>
                {gridProfileToken}
              </Typography>
              <Typography component="div">{I18n.t('dashboard.validText', { serialNumber: serialNumber })}</Typography>
            </DialogContentText>
          ) : (
            <Fragment>
              <DialogContentText component="div" className={classes.dialogContentText}>
                <TextField
                  id="envoy_serial_number"
                  className={clsx(classes.inputField, labelClass.customLabel)}
                  label={<Label text={I18n.t('dashboard.envoySerialNumber')} />}
                  value={serialNumber}
                  onKeyPress={e => preventDefault(e)}
                  onChange={e => setSerialNumber(e.target.value)}
                />
              </DialogContentText>
              <DialogContentText component="div" className={classes.dialogContentText}>
                <TextField
                  id="authorization_number"
                  className={clsx(classes.inputField, labelClass.customLabel)}
                  label={<Label text={I18n.t('dashboard.authorizationNumber')} />}
                  value={authNumber}
                  onChange={e => setAuthNumber(e.target.value)}
                />
              </DialogContentText>
              <Button
                onClick={() => getToken()}
                color="primary"
                variant="contained"
                disableElevation
                className={classes.button}
              >
                {I18n.t('dashboard.getToken')}
              </Button>
            </Fragment>
          )}
        </DialogContent>
      </Dialog>
      {errorMessage && <Snackbar severity="error" message={errorMessage} />}
    </Fragment>
  );
};

const mapDispatchToProps = dispatch => ({
  getGridProfileToken: payload => dispatch(getGridProfileToken(payload))
});
const mapStateToProps = state => ({});

export default connect(mapStateToProps, mapDispatchToProps)(GridProfileToken);
